// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xG6K","label":"styles_label__28CzZ"};